export default {
  subscription_program: (id: string) => `/v1/subscriptions/programs/${id}`,
  subscription_unit: (id: string) => `/v1/subscriptions/units/${id}`,
  assignment_programs: (id: string) =>
    `/v1/subscriptions/${id}/assignment_programs`,
  assignment_programs_unscheduled: (id: string) =>
    `/v1/subscriptions/${id}/assignment_programs_unscheduled`,
  calculate_unit: (id: string) => `/v1/subscriptions/units/${id}/calculate`,
  reassign: (id: string) => `/v1/subscriptions/units/${id}/reassign`,
  progress: `/v1/subscriptions/progress`,
  inspectors: `/v1/subscriptions/inspectors`,
  continue: (id: string) => `/v1/subscriptions/${id}/continue`,
  confirmation_info: (id: string) =>
    `/v1/subscriptions/${id}/confirmation_info`,
  confirmations: (student_id: string) =>
    `/v1/subscriptions/${student_id}/confirmations`,
  confirm_program_result: (id: string) =>
    `/v1/subscriptions/${id}/confirm_program_result`,
  delegate_confirmation_program: (id: string) =>
    `/v1/subscriptions/${id}/delegate_confirmation_program`,
  not_started_unit: (id: string) =>
    `/v1/subscriptions/units/${id}/not_started_unit`,
  event_with_trainer_available: (id: string) =>
    `/v1/subscriptions/units/${id}/event_with_trainer_available`
};
